import React from 'react';
import PropTypes from 'prop-types';
import NeedsAnalysisStackedButton from '../../../Tools/NeedsAnalysis/NeedsAnalysisStackedButton';

export default function TermInsuranceNeedAnalysisTool(props) {
  const { toolName, title, setCoverageAmount } = props;

  return (
    <NeedsAnalysisStackedButton
      type="quote-screen"
      condensed
      minCoverageAmount={25000}
      maxCoverageAmount={1500000}
      setCoverageAmount={setCoverageAmount}
      toolName={toolName}
      title={title}
      isCustomTerm={true}
    />
  );
};

TermInsuranceNeedAnalysisTool.propTypes = {
  toolName: PropTypes.string,
  title: PropTypes.string,
  setCoverageAmount: PropTypes.func,
};
